import * as React from 'react';
import {Animated, StyleSheet, Text, TextStyle, View} from 'react-native';
import NotificationIcon from './icons/NotificationIcon';

import {colors} from '../../styles/variables';

interface Props {
  badgeCount?: number | null;
  disabled: boolean;
}

const NotificationIconWithBadgeCount: React.FunctionComponent<
  Props
> = props => {
  const {badgeCount, disabled} = props;
  const [scale] = React.useState(new Animated.Value(0));
  React.useEffect(() => {
    Animated.timing(scale, {
      toValue: badgeCount ? 1 : 0,
      duration: 300,
      useNativeDriver: false,
    }).start();
  }, [!!badgeCount]);
  return (
    <View>
      <NotificationIcon
        size={21}
        color={disabled ? '#d5d5d5' : badgeCount ? colors.orange : '#383838'}
      />
      {!badgeCount ? null : (
        <Animated.Text style={[styles.badge, {transform: [{scale}]}]}>
          {badgeCount}
        </Animated.Text>
      )}
    </View>
  );
};

export default React.memo(NotificationIconWithBadgeCount);

const styles = StyleSheet.create({
  badge: {
    position: 'absolute',
    width: 14,
    height: 14,
    borderRadius: 7,
    top: -3,
    right: -6,
    backgroundColor: 'red',
    color: 'white',
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: 14,
  } as TextStyle,
});
